'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes$1 = _interopDefault(require('prop-types'));
require('styled-components');
var _babelHelpers = require('../_babelHelpers-48e7a7f7.js');
var settings = require('../settings-9ee2f03f.js');
require('lodash/camelCase');
require('lodash/upperFirst');
var icon = require('../icon.js');
require('../browser-05a2bba8.js');
require('react-dom');
require('../_commonjsHelpers-3fc1f64e.js');
require('../_react_commonjs-external-30e5c7b3.js');
require('../_prop-types_commonjs-external-c51b2bd5.js');
require('../style-222d2b0f.js');
var span = require('../typography/span.js');
var styles = require('../styles-e130111c.js');
require('../index-45be2fcd.js');
require('../invariant-8c441586.js');
require('../react-lifecycles-compat.es-59afd828.js');
require('../_react-dom_commonjs-external-3c49a59a.js');
var transparent = require('../button/transparent.js');

var ArrayFieldGroupContainer = function ArrayFieldGroupContainer(_ref) {
  var children = _ref.children,
      addButtonText = _ref.addButtonText,
      onClickAddButton = _ref.onClickAddButton,
      dropdownOptions = _ref.dropdownOptions,
      addable = _ref.addable,
      addBtnId = _ref.addBtnId,
      margin = _ref.margin,
      padding = _ref.padding,
      handleClickDropdown = _ref.handleClickDropdown;

  var hasDropdown = dropdownOptions.length > 0;
  return React__default.createElement(
    "div",
    null,
    children,
    addable && React__default.createElement(
      "div",
      null,
      hasDropdown ? React__default.createElement(
        styles.StyleDropDown,
        null,
        React__default.createElement(
          styles.Dropdown.Toggle,
          { noCaret: true, variant: "success", id: "dropdown-basic" },
          React__default.createElement(
            transparent.TransparentButton,
            {
              id: addBtnId,
              type: "button",
              color: settings.COLOR.brightBlue,
              hoverColor: settings.COLOR.deepBlueHover,
              weight: "600",
              padding: padding,
              margin: margin },
            React__default.createElement(icon.Icon, { icon: "add" }),
            React__default.createElement(
              span,
              { margin: "0 0 0 5px", size: "16px", lineHeight: "22px" },
              addButtonText
            )
          )
        ),
        React__default.createElement(
          styles.Dropdown.Menu,
          null,
          dropdownOptions.map(function (_ref2) {
            var value = _ref2.value,
                label = _ref2.label,
                field = _ref2.field;
            return React__default.createElement(
              styles.StyledMenuItem,
              {
                onClick: handleClickDropdown(_babelHelpers.defineProperty({}, field, value)) },
              " ",
              label,
              " "
            );
          })
        )
      ) : React__default.createElement(
        transparent.TransparentButton,
        {
          id: addBtnId,
          type: "button",
          color: settings.COLOR.brightBlue,
          hoverColor: settings.COLOR.deepBlueHover,
          weight: "600",
          padding: padding,
          margin: margin,
          onClick: onClickAddButton },
        React__default.createElement(icon.Icon, { icon: "add" }),
        React__default.createElement(
          span,
          { margin: "0 0 0 5px", size: "16px", lineHeight: "22px" },
          addButtonText
        )
      )
    )
  );
};
ArrayFieldGroupContainer.propTypes = {
  /** text to display on add field group button */
  addButtonText: PropTypes$1.string,
  /** function to execute when click add field group button */
  onClickAddButton: PropTypes$1.func,
  /** status to display add button */
  addable: PropTypes$1.bool,
  /** Button ID */
  addBtnId: PropTypes$1.string.isRequired,

  dropdownOptions: PropTypes$1.array
};

ArrayFieldGroupContainer.defaultProps = {
  addable: true,
  dropdownOptions: []
};
ArrayFieldGroupContainer.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ArrayFieldGroupContainer",
  "props": {
    "addable": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "status to display add button"
    },
    "dropdownOptions": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    },
    "addButtonText": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "text to display on add field group button"
    },
    "onClickAddButton": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "function to execute when click add field group button"
    },
    "addBtnId": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Button ID"
    }
  }
};

module.exports = ArrayFieldGroupContainer;
//# sourceMappingURL=container.js.map
